const ENDPOINTS = {
  CEREMONY_SESSIONS: '/sessions',
  CEREMONY_COMPLETE: '/complete',
};

export default ENDPOINTS;
